// Where the app is published (handover Phase E: the Play Store first, as a Trusted Web
// Activity). Both are null until the owner has them: set them here, once, and the install and
// privacy pages pick them up.

/**
 * The Play Store listing, e.g. `https://play.google.com/store/apps/details?id=<package id>`.
 * Null until the package id exists (Play Console, O6): the install page then says the store
 * listing is on its way and installs from the page.
 */
export const PLAY_STORE_URL: string | null = null

/**
 * How a parent reaches the developer (Google Play requires a contact on the privacy policy).
 * Cloudflare Email Routing forwards it to the owner (docs/OWNER_CHECKLIST.md); null leaves the
 * privacy page's line out.
 */
export const SUPPORT_CONTACT: string | null = 'hello@outofscopestudios.com'
